import DataTable from 'react-data-table-component'
import styles from './ManualBid.module.scss'
import { useState } from 'react'
import AddKeywordsAndBidsModal from './AddKeywordsAndBidsModal/AddKeywordsAndBidsModal'
import SecondaryButton from '../../../../../components/common/SecondaryButton/SecondaryButton'

const ManualBid = () => {

  const [showModal, setShowModal] = useState(false)

  const selectedProductsData = [
    { name: 'Blue Colored Headphones', totalKeywordsSelected: 30, avgBidAmount: '$1.00' },
    { name: 'Blue Colored Headphones', totalKeywordsSelected: 30, avgBidAmount: '$1.00' },
    { name: 'Blue Colored Headphones', totalKeywordsSelected: 30, avgBidAmount: '$1.00' },
    { name: 'Blue Colored Headphones', totalKeywordsSelected: 30, avgBidAmount: '$1.00' },
    { name: 'Blue Colored Headphones', totalKeywordsSelected: 30, avgBidAmount: '$1.00' },
  ]

  const selectedProductsDatacolumns = [
    { name: 'Product Name', selector: row => row.name },
    { name: 'Total Key Words Selected', selector: row => row.totalKeywordsSelected, center: true },
    { name: 'Average Bid Amount', selector: row => row.avgBidAmount, center: true },
    { name: "Action", cell: () => (<div className='d-flex gap-2'><div className='cursor-pointer'>Edit</div><div className='cursor-pointer'>Remove</div></div>) }
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div>
      <div className={styles['heading']}>Adding Keywords and Bid </div>
      <div className='p-2 bg-white'>

        <div className={styles['wrapper']}>
          <div>
            <SecondaryButton name='Add Keywords and Bids' onClick={() => setShowModal(!showModal)} />
          </div>
          <DataTable data={selectedProductsData} columns={selectedProductsDatacolumns} customStyles={customStyles} responsive />
        </div>

      </div>
      <AddKeywordsAndBidsModal isModalOpen={showModal} setIsModalOpen={setShowModal} />

    </div>
  )
}

export default ManualBid